<ion-card>
  <ion-card-header>
    <ion-card-title>Hibajegy – Redmine kapcsolat</ion-card-title>
    <ion-card-subtitle>Ide mennek a felhasználók hibabejelentései, és innen jönnek vissza a válaszok</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
    <ion-note color="danger" *ngIf="!toltodik && hiba" class="hb-blokk">{{ hiba }}</ion-note>

    <ng-container *ngIf="!toltodik && !hiba">
      <ion-note color="medium" class="hb-blokk">
        A munkatársak és a gondviselők a <b>Hibajelentés</b> menüpontban írhatnak bejelentést. A jegy ebbe a
        Redmine-projektbe kerül; az állapotváltásokat és a <b>nyilvános</b> megjegyzéseket a rendszer ötpercenként
        visszahozza, és a bejelentő a menüben jelvényként látja. A <b>privát</b> megjegyzések nem jutnak el hozzá.
      </ion-note>

      <ion-grid class="hb-racs">
        <ion-row>
          <ion-col size="12" sizeMd="8">
            <ion-input label="Redmine címe" label-placement="stacked" fill="outline"
                       placeholder="https://redmine.pelda.hu" [(ngModel)]="b.redmine_url"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="4">
            <ion-input label="Projekt (azonosító vagy szám)" label-placement="stacked" fill="outline"
                       placeholder="pl. sulinform-tamogatas" [(ngModel)]="b.projekt"></ion-input>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="API-kulcs" label-placement="stacked" fill="outline" type="password" autocomplete="off"
                       [placeholder]="kulcsBeallitva ? 'beállítva – üresen hagyva marad' : 'nincs beállítva'"
                       [(ngModel)]="kulcs"></ion-input>
            <ion-item lines="none" *ngIf="kulcsBeallitva" class="hb-kapcsolo">
              <ion-checkbox [(ngModel)]="kulcsTorles" labelPlacement="end">A tárolt kulcs törlése mentéskor</ion-checkbox>
            </ion-item>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-input label="Tracker (nem kötelező)" label-placement="stacked" fill="outline" type="number"
                       placeholder="a projekt alapértelmezése" [(ngModel)]="b.tracker_id"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-select label="Szövegformázás" label-placement="stacked" fill="outline" interface="popover"
                        [(ngModel)]="b.formatum">
              <ion-select-option *ngFor="let f of formatumok" [value]="f">{{ formatumNev(f) }}</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <ion-note color="medium" class="hb-kicsi">
              A <b>szövegformázás</b> a Redmine Adminisztráció → Beállítások → Általános → „Szövegformázás"
              értéke legyen: ettől jelenik meg a bejelentés szövege és az adattábla helyesen.
            </ion-note>
          </ion-col>
        </ion-row>
      </ion-grid>

      <h3 class="hb-cim">Bekapcsolva</h3>
      <ion-item lines="none" *ngFor="let a of tamogatott" class="hb-kapcsolo">
        <ion-toggle [checked]="bekapcsolva(a)" (ionChange)="alrendszerValt(a, $event.detail.checked)"
                    labelPlacement="end">{{ modeNev(a) }}</ion-toggle>
      </ion-item>

      <div class="hb-gombok">
        <ion-button (click)="mentes()" [disabled]="ment">
          <ion-spinner *ngIf="ment" name="dots"></ion-spinner>Mentés
        </ion-button>
        <ion-button fill="outline" (click)="kapcsolatProba()" [disabled]="probaFut">
          <ion-spinner *ngIf="probaFut" name="dots"></ion-spinner>Kapcsolat próba
        </ion-button>
        <ion-button fill="clear" (click)="szinkronMost()" [disabled]="szinkronFut">
          <ion-spinner *ngIf="szinkronFut" name="dots"></ion-spinner>Szinkron most
        </ion-button>
      </div>

      <div *ngIf="proba" class="hb-eredmeny" [class.ok]="proba.ok" [class.baj]="!proba.ok">
        <div *ngIf="proba.felhasznalo">API-felhasználó: <b>{{ proba.felhasznalo.nev || proba.felhasznalo.login }}</b>
          ({{ proba.felhasznalo.login }}, #{{ proba.felhasznalo.id }})</div>
        <div *ngIf="proba.projekt">Projekt: <b>{{ proba.projekt.nev }}</b> ({{ proba.projekt.azonosito }}, #{{ proba.projekt.id }})</div>
        <div *ngIf="proba.kategoriak">Iskola-kategóriák a projektben: <b>{{ proba.kategoriak.length ? proba.kategoriak.join(', ') : 'még nincs – az első bejelentés létrehozza' }}</b></div>
        <div *ngFor="let h of proba.hibak">{{ h }}</div>
        <div *ngIf="proba.ok">A kapcsolat rendben – ne felejtsd el menteni.</div>
      </div>
      <div *ngIf="szinkron" class="hb-eredmeny" [class.baj]="szinkron.hiba">
        <span *ngIf="szinkron.kihagyva">A szinkron nem fut: {{ szinkron.kihagyva }}.</span>
        <span *ngIf="!szinkron.kihagyva">
          Elküldött jegy: {{ szinkron.elkuldott || 0 }} · elküldött válasz: {{ szinkron.valasz || 0 }} ·
          frissített jegy: {{ szinkron.frissitett || 0 }}<span *ngIf="szinkron.hiba"> · hiba: {{ szinkron.hiba }}</span>
        </span>
      </div>

      <div class="hb-stat" *ngIf="statisztika">
        Összesen <b>{{ statisztika.osszes }}</b> jegy, ebből nyitott <b>{{ statisztika.nyitott }}</b>,
        továbbításra vár <b>{{ statisztika.kuldesre_var }}</b>
        <span *ngIf="statisztika.hibas"> (ebből a Redmine által elutasított: <b>{{ statisztika.hibas }}</b>)</span>.
        <span *ngIf="statisztika.utolso_szinkron">Utolsó szinkron: {{ statisztika.utolso_szinkron | date:'yyyy. MM. dd. HH:mm' }}.</span>
        <span *ngIf="modositva"> Beállítás módosítva: {{ modositva | date:'yyyy. MM. dd. HH:mm' }}<span *ngIf="modosito"> ({{ modosito }})</span>.</span>
      </div>

      <ion-note color="medium" class="hb-blokk hb-kicsi">
        <b>A Redmine oldalán:</b> legyen bekapcsolva a REST API (Adminisztráció → Beállítások → API). Az API-felhasználó
        a projektben kapjon olyan szerepkört, amiben megvan a <i>Feladatok megtekintése</i>, <i>Feladat hozzáadása</i>,
        <i>Megjegyzés hozzáadása</i> és a <i>Fájlok feltöltése</i> jog. A <i>privát megjegyzések megtekintése</i> jog
        NEM kell (és jobb, ha nincs meg). A mellékletek felső méretkorlátját is a Redmine szabja meg (alapból 5 MB);
        ami nagyobb, az a Sulinformban megmarad, a jegyben pedig jelezzük, hogy nem ment át.
        <br><b>Iskola szerinti szűrés:</b> minden jegy a bejelentő iskolájáról elnevezett <i>kategóriát</i> kapja; ha még
        nincs ilyen, a Sulinform létrehozza – ehhez a <i>Jegykategóriák kezelése</i> jog is kell. A Redmine jegylistájában
        a <i>Kategória</i> szűrővel, csoportosítással vagy oszlopként látszik, honnan jött a jegy.
      </ion-note>
    </ng-container>
  </ion-card-content>
</ion-card>
